import type { Scenario, Share } from "@/lib/powtoon-be/types";

export type SharePermission = "view" | "edit";

/** Permissions payload for a colleague share. Team shares stay view-only. */
export function permissionList(p: SharePermission): string[] {
  return p === "edit" ? ["can_view", "can_edit"] : ["can_view"];
}

export function sharePermission(share: Pick<Share, "permissions">): SharePermission {
  return share.permissions?.includes("can_edit") ? "edit" : "view";
}

/**
 * Colleague editing is off until the backend lets a recipient read their own
 * access (VCP-25637). While off, only the owner can edit.
 */
export const COLLEAGUE_EDIT_ENABLED = false;

/**
 * Owner, or (when enabled) a colleague with a direct user share carrying `can_edit`.
 * Group (team) shares never grant edit.
 */
export function canEditScenario(
  scenario: Pick<Scenario, "owner"> | undefined,
  userId: number | null | undefined,
  shares?: Share[] | null,
  colleagueEdit: boolean = COLLEAGUE_EDIT_ENABLED,
): boolean {
  if (!scenario || userId == null) return false;
  if (scenario.owner === userId) return true;
  if (!colleagueEdit) return false;
  return (shares ?? []).some(
    (s) =>
      s.grantee_type === "user" &&
      String(s.grantee_id) === String(userId) &&
      sharePermission(s) === "edit",
  );
}
